/* eslint-disable no-console */
import axios, { AxiosError } from "axios";
import { axiosRequestConfig, BaseMembershipUrl } from "../apiConstants"

export interface IIsNewMemberResponse {
	isNewMember: boolean;
}

const getIsNewMember = async (id: number, jwt: string) => {
	try {
		return await axios.get<IIsNewMemberResponse>(
			`${BaseMembershipUrl}/History/IsNewMember/${id}`,
			axiosRequestConfig(jwt)
		);
	} catch (err) {
		console.error("error: ", err);
		return (err as AxiosError).response;
	}
};

export default getIsNewMember;
